import { EntityConfig } from "@/hooks/useEntity";

// Define the Citation entity schema
export type CitationData = {
  documentId: number;
  citationType: "book" | "journal" | "website" | "article" | "other";
  authors: string; // Comma-separated or JSON string
  title: string;
  year: string;
  publisher?: string;
  url?: string;
  doi?: string;
  pages?: string;
  volume?: string;
  issue?: string;
  inTextLocations?: string; // JSON string of locations
  formattedReference?: string;
};

export const citationEntityConfig: EntityConfig<CitationData> = {
  entityType: "Citation",
  required: ["documentId", "citationType", "authors", "title", "year"],
  orderBy: [], // Sorting is always client-side
};